import { render } from "./DiagnostFormVerify.vue?vue&type=template&id=380c81c7&scoped=true"
import script from "./DiagnostFormVerify.vue?vue&type=script&lang=js"
export * from "./DiagnostFormVerify.vue?vue&type=script&lang=js"

import "./DiagnostFormVerify.vue?vue&type=style&index=0&id=380c81c7&scoped=true&lang=css"

import exportComponent from "/builds/shapkin/crm-mentoring.exportedu.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380c81c7"]])

export default __exports__